<template>
  <div id="saloon-stand-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px;">
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-8">
                    <label>{{this.$t('event.table.title')}}</label>
                    <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                    <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                  </div>

                  <div class="form-group col-md-4">
                    <label style="display: block">{{this.$t('event.table.sequence')}}</label>
                    <el-input-number v-model="form.orderNO" :min="1"></el-input-number>
                    <span class="error">{{ $errorMessage("orderNO", validationErrors) }}</span>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 0"
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button slot="reference" type="danger" icon="fas fa-trash">{{ this.$t('event.table.delete') }}</el-button>
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="display: flex; flex: 1; align-items: center; justify-content: flex-end"
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                      >{{$t('event.buttons.close')}}</el-button>
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="display: flex; width: 100%; align-items: center; justify-content: center; cursor: pointer; padding: 10px 0px"
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import GroupAddUpdate from "./GroupAddUpdate";
export default {
  components: { ItemInfo, GroupAddUpdate },
  name: "WallAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        orderNO: 1
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false
    };
  },
  mounted() {},
  methods: {
    async itemAdded(id) {
      this.addGroupModal = false;
      await this.$store.dispatch("getGroups");
      this.form.groupID = id;
    },
    deleteItem() {
      var index = this.$store.state.packetcategory.items.findIndex(
        k => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];
      axios.post("packetcategory/addorupdate", this.form).then(res => {
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          if (this.form.id == null) {
            this.$emit("itemAdded");
            this.form = {
              id: null,
              title: null,
              orderNO: 1
            };
          } else {
            this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
            if (this.showInfo) {
              this.showInfo = false;
              setTimeout(() => {
                this.showInfo = true;
              }, 350);
            }
          }
        }
      });
    }
  },
  watch: {
    data: function(newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          orderNO: 1
        };
      }
    },
    "form.groupID": function(newVal) {
      if (newVal == -1) {
        this.form.groupID = null;
        this.addGroupModal = true;
      }
    }
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PacketCategoryAddUpdate.vue